import { useTranslation } from "react-i18next"

import { SectionHeading } from "../components/SectionHeading"
import { TelegramIcon } from "../components/TelegramIcon"
import {
  CONTAINER,
  H3,
  KV_ITEM,
  KV_LABEL,
  KV_LIST,
  KV_VALUE,
  SECTION,
} from "../components/styles"
import { ANCHORS, DOWNLOAD_PAGE_URL, SITE } from "../site-config"

/** 联系我们：官方客服渠道 + 下载卡片（CTA 导向下载页） */
export function ContactSection() {
  const { t } = useTranslation()

  const rows = [
    {
      label: t("official_contact_kv_email"),
      value: SITE.supportEmail,
      href: `mailto:${SITE.supportEmail}`,
    },
    {
      label: t("official_contact_kv_support"),
      value: SITE.supportOnline,
      href: SITE.supportOnlineUrl,
      icon: <TelegramIcon />,
    },
    {
      label: t("official_contact_kv_company_phone"),
      value: SITE.companyPhone,
    },
    {
      label: t("official_contact_kv_address"),
      value: SITE.address,
    },
    {
      label: t("official_contact_kv_privacy"),
      value: SITE.privacyEmail,
      href: `mailto:${SITE.privacyEmail}`,
    },
  ]

  return (
    <section id={ANCHORS.contact} className={`${SECTION} scroll-mt-[68px]`}>
      <div
        className={`${CONTAINER} grid items-start gap-8 lg:grid-cols-[1.3fr_0.7fr]`}
      >
        <div>
          <SectionHeading
            eyebrow={t("official_contact_eyebrow")}
            title={t("official_contact_title")}
            lead={t("official_contact_lead")}
          />

          <ul
            className={`${KV_LIST} rounded-[20px] border border-line bg-white px-5 py-2 shadow-card`}
          >
            {rows.map((row) => (
              <li key={row.label} className={KV_ITEM}>
                <span className={KV_LABEL}>{row.label}</span>
                <b className={KV_VALUE}>
                  {row.href ? (
                    <a href={row.href} className="text-primary hover:underline">
                      {row.icon && <span className="mr-1.5">{row.icon}</span>}
                      {row.value}
                    </a>
                  ) : (
                    row.value
                  )}
                </b>
              </li>
            ))}
          </ul>

          <p className="mt-4 text-sm leading-[1.7] text-ink-tertiary">
            {t("official_contact_response", { days: SITE.responseDays })}
          </p>
        </div>

        <aside className="rounded-[20px] bg-ink p-7 text-white">
          <h3 className={`${H3} text-white`}>
            {t("official_contact_card_title")}
          </h3>

          <a
            href={DOWNLOAD_PAGE_URL}
            className="my-3.5 block rounded-full bg-primary px-[22px] py-3 text-center text-[15px] font-semibold text-white transition hover:bg-primary-600"
          >
            {t("official_contact_card_btn")}
          </a>
          <p className="m-0 text-[13px] leading-[1.6] text-white/70">
            {t("official_contact_card_tip")}
          </p>
        </aside>
      </div>
    </section>
  )
}
